<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">
  <div class="row margin-bottom-10px" id="edit-link">
    <div class="col-md-12">
      <div class="card box-shadow-new-treatmentcycle border-left-pre ">
        <div class="card-header wh-header border-bottom-1px padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
          <div class="row nav-link-hand margin-left-0px margin-right-0px background-new-pre data-color-white">
            <div class="col-md-6 padding-right-0px">
              <label class="margin-bottom-0px font-size-16px font-weight-normal" id="et">
                <!--<i class="fas fa-circle light-gray-badge nav-link-hand  ">
                </i>-->
                Pregnency Tracker
              </label>
            </div>
            <div class="col-md-6  padding-right-0px display-edit">
              <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
              <div class="row  margin-left-0px margin-right-0px">


                <div class="offset-md-5 col-md-2 padding-right-0px">
                  <!--<a class="nav-link-hand education-navlink " title="To View images">
      <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
    </a>-->
                  <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="EditPre()"><i class="fas fa-pencil-alt"></i></button>
                </div>
                <div class="col-md-2 padding-right-5px">
                  <!--<a class="nav-link-hand education-navlink " title="To View images">
      <span class="badge font-size-20px padding-left-0px padding-right-0px padding-bottom-0px padding-top-0px"><i class="far fa-image"></i></span>
    </a>-->
                 
                  <button type="button" class="btn actions-btn-prime float-right font-size-15px padding-right-0px padding-left-0px min-width-32px" (click)="printtransfer()"><i class="fa fa-print"></i></button>

                  <!--<a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Well Culture'" title="print" (click)="printoocyte()">
      <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
    </a>
    <a class="nav-link-hand education-navlink" *ngIf="GradingModel=='Droplet Culture'" title="print" (click)="printoocytedroplet()">
      <span class="badge font-size-14 padding-left-0px"><i class="fa fa-print"></i></span>
    </a>-->

                </div>
                <div class="col-md-1 padding-left-11px">
                  <!--<button type="button"
            class="btn  btn-sm drive-button3 background-primary border-all-secondary" id="FileUpload"
            name="upload">
      <i class="fas fa-plus font-size-11"></i>
    </button>-->
                  <button type="button" (click)="Top()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload">
                    <i class="fas fa-arrow-alt-circle-up color-green font-size-18px"></i>
                    <!--<i class="fas fa-long-arrow-alt-up font-size-11"></i>-->
                  </button>

                </div>
                <div class="col-md-1 padding-left-11px">
                  <button type="button" (click)="Bottom()"
                          class="btn  btn-sm drive-button4 background-primary border-all-secondary" id="FileUpload"
                          name="upload" title="Goto Bottom">
                    <i class="fas fa-arrow-alt-circle-down color-green font-size-18px"></i>
                    <!--<i class="fas fa-long-arrow-alt-down font-size-11 "></i>-->
                  </button>
                </div>
              </div>




            </div>

          </div>
        </div>
        <div class="card-body padding-top-0px padding-left-0px padding-right-0px">
          <div class="row margin-left-0px margin-top-15px">
            <div class="col-md-12">
              <div class="accordion margin-bottom-20px" id="accordionExampleTest">
                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTest">
                    <div class="row">
                      <div class="col-md-4">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTest" aria-expanded="true" aria-controls="collapseTest">
                            Procedures/Tests
                          </button>
                        </h5>
                      </div>
                      <div class="col-md-8 ">
                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                        <!--<button type="button"
                        class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                        name="upload" >
                  <i class="fas fa-plus font-size-11"></i>
                </button>-->
                        <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                      </div>
                      <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                    </div>


                  </div>

                  <div id="collapseTest" class="collapse show" aria-labelledby="headingTest" data-parent="#accordionExampleTest">
                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                      <div class="card margin-bottom-0px">
                        <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                        <div class="card-body padding-top-0px padding-bottom-0px">
                          <div class="row">
                            <div class="col-lg-11 col-md-11 col-xs-11 padding-right-0px">
                              <div class="table-component table-tests">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">

                                    <tbody class="table-body">

                                      <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                        <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                        <td class="padding-top-4px padding-bottom-4px padding-right-0px">{{RowIndex+1}}</td>
                                        <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                          <div class="height-16px">
                                            <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                          </div>
                                          <div class="row-height-17px">
                                            <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                          </div>
                                        </td>
                                        <td class="padding-top-4px padding-bottom-4px">
                                          <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                  </a>-->
                                          <!--<div class="test-icons float-right">
                                    <a (click)="delTEST(l)" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>

                                  </div>-->
                                        </td>




                                      </tr>

                                    </tbody>
                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="row margin-left-0px margin-top-15px">
            <div class="col-md-12">
              <div class="accordion margin-bottom-20px" id="accordionExampleMed">
                <div class="card margin-bottom-5px">
                  <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingMed">
                    <div class="row">
                      <div class="col-md-4">
                        <h5 class="mb-0 height-24px">
                          <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseMed" aria-expanded="true" aria-controls="collapseMed">
                            Medicines
                          </button>
                        </h5>
                      </div>
                      <div class="col-md-8 ">
                        <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                        <!--<button type="button"
                        class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                        name="upload" *ngIf="EmbryoTransferData2.ActivityStatus =='Completed'">
                  <i class="fas fa-plus font-size-11"></i>
                </button>-->
                        <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                      </div>
                      <!--<div class="col-md-6">
                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
              </div>-->
                    </div>


                  </div>

                  <div id="collapseMed" class="collapse show" aria-labelledby="headingMed" data-parent="#accordionExampleMed">
                    <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                      <div class="card margin-bottom-0px">
                        <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                  <div class="row">
                    <div class="col-md-3">
                      <label class="font-weight-normal font-size-14">Add/Edit</label>
                    </div>
                    <div class="col-md-3 text-align-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                    </div>
                  </div>

                </div>-->
                        <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                          <div class="col-lg-11 col-md-11 col-xs-11 col-11 padding-right-0px ">


                            <div class="table-component">
                              <div class="table-responsive">


                                <table class="table table-striped margin-left-zero width-50-new">
                                  <!--<thead>
                                                              <tr>
                                                                <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                </th>

                                                                <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>
                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>
                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                          </th>


                                                                <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                </th>











                                                              </tr>
                                                            </thead>-->
                                  <tbody class="table-body">

                                    <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                      <td class="padding-top-4px padding-bottom-4px ">{{RowIndex+1}}</td>
                                      <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                <div class="height-16px" >
                                  <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
                                </div>
                                <div class="height-16px" >
                                  <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                                </div>

                              </td>-->
                                      <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                      <td class=" padding-top-4px padding-bottom-4px ">{{l.Dosage}}</td>
                                      <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                      <td class=" padding-top-4px padding-bottom-4px ">{{l.Instructions}}</td>

                                      <!--<td class="padding-top-4px padding-bottom-4px ">
                                <div class="test-icons">
                                  <a class="float-right" (click)="delMedicine(l)" title="Remove" *ngIf="!SelectedpatientDetails.IsReadyForPickup"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                                </div>
                              </td>-->
                                      <!--<td class="padding-top-4px padding-bottom-4px">


                              </td>-->




                                    </tr>

                                  </tbody>
                                </table>

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div class="row">
            <div class="col-md-12">
              <ivf-additional-detail [CycleCode]='CycleCode'
                                     Title="Additional Information"
                                     Context="PregTrackAdnDetail">
              </ivf-additional-detail>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>



